/**
 * Shown on a customer or organization that HuHoKa CRM manages (plan 14,
 * Phase 2): the synced fields are read-only here and are edited in HuHoKa CRM.
 * The BFF supplies `externalEditUrl` ({remoteWebUrl}/clients/{externalId}) only
 * while the link is active and only as an https address.
 */
export function isManagedByCrm(record: { managedBy?: string | null } | null | undefined): boolean {
  return !!record?.managedBy;
}

export function ManagedByCrmNotice({
  managedBy,
  editUrl,
  fields,
  className,
}: {
  managedBy?: string | null;
  editUrl?: string | null;
  /** e.g. "Name, email and phone" */
  fields: string;
  className?: string;
}) {
  if (!managedBy) return null;
  const product = managedBy === 'huhoka' ? 'HuHoKa CRM' : managedBy;
  return (
    <div
      className={
        className ??
        'mb-4 rounded-lg border border-blue-200 bg-blue-50 p-3 text-sm text-blue-800 dark:border-blue-800 dark:bg-blue-900/20 dark:text-blue-200'
      }
      data-testid="managed-by-crm-notice"
    >
      {fields} {fields.includes(' and ') ? 'are' : 'is'} managed in {product}.{' '}
      {editUrl ? (
        <a href={editUrl} target="_blank" rel="noopener noreferrer" className="font-medium underline">
          Edit in {product} ↗
        </a>
      ) : (
        <span>Edit {fields.includes(' and ') ? 'them' : 'it'} there.</span>
      )}
    </div>
  );
}
